<template>

<div>
  <PageTitle :route="$route" />

  <PageRowWrapper>
    <UsersForm />
  </PageRowWrapper>
</div>

</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import UsersForm from '@/components/settings/users/users/UsersForm'

export default {
  name: 'Users',
  components: {
    PageTitle,
    PageRowWrapper,
    UsersForm
  }
}
</script>
